import { fetchLogIn, resetRegistration, selectRegistrationData, updateUser } from 'containers/Login/loginSlice'
import SimplifiedSummary from 'containers/OrderDetails/Summary/SimplifiedSummary'
import { selectBasketIsEmpty } from 'containers/OrderDetails/basketSlice'
import InaccessiblePopup from 'components/popups/InaccessiblePopup'
import ConsentPreviewPopup from 'components/popups/ConsentPreview'
import { useDispatch, useSelector } from 'react-redux'
import { resetForm, updateValues } from '../formSlice'
import VerificationPopup from './VerificationPopup'
import useTranslation from 'hooks/useTranslation'
import { parseApiErrors } from 'rest/apiErrors'
import { useHistory } from 'react-router-dom'
import { getPhoneParts } from 'utils/phone'
import { useEffect, useState } from 'react'
import { register, user } from 'rest/urls'
import { PATCH, POST } from 'rest/request'
import WarningPopup from './WarningPopup'
import Loading from 'components/Loading'
import { STATUS } from 'utils/constants'
import Form from './Form'
import '../style.scss'
import './style.scss'

const INIT_POPUP = {
  type: '',
  content: '',
}

const Registration = ({ goToLoginForm, button, callback, isDesktop }) => {
  const registration = useSelector(selectRegistrationData)
  const isBasketEmpty = useSelector(selectBasketIsEmpty)
  const [status, setStatus] = useState(STATUS.idle)
  const [popup, setPopup] = useState(INIT_POPUP)
  const [warning, setWarning] = useState({
    firstName: false,
    lastName: false,
    mail: false,
    phone: false,
    password: false,
    passwordSec: false,
    rulesAgreement: false,
  })

  const { goBack, replace } = useHistory()
  const { t } = useTranslation('form')
  const dispatch = useDispatch()

  const hidePopup = () => setPopup(INIT_POPUP)
  const showPopup = (content, type = 'error') => setPopup({ type, content })

  const loginUser = user => {
    if (!user) return
    setStatus(STATUS.pending)
    dispatch(fetchLogIn(user)).then(({ payload }) => {
      dispatch(resetForm())
      if (callback) callback(payload)
      else if (window.history) goBack()
      else replace('/login')
    })
  }

  const showWarning = (error) => {
    const newWarning = {}
    const { fields } = parseApiErrors(error)
    if (fields.first_name) newWarning.firstName = fields.first_name
    if (fields.surname) newWarning.lastName = fields.surname
    if (fields.email) newWarning.mail = fields.email
    if (fields.phone) newWarning.phone = fields.phone
    if (fields.password) newWarning.password = fields.password
    if (fields.password_confirmation) newWarning.passwordSec = fields.password_confirmation
    setWarning(newWarning)
  }

  const submit = async body => {
    setStatus(STATUS.pending)

    try {
      const response = await POST(register, { body, credentials: true })
      if (response) {
        const { email, password } = body
        const { need_phone_otp } = response
        const content = { username: email, password }

        if (need_phone_otp && isBasketEmpty) {
          setStatus(STATUS.succeed)
          showPopup(content, 'verification')
        } else {
          loginUser(content)
        }
      }

    } catch (error) {
      setStatus(STATUS.failed)
      showWarning(error)
    }
  }

  const updateUserData = async body => {
    setStatus(STATUS.pending)

    try {
      const response = await PATCH(user, { body })
      if (response?.data) {
        dispatch(updateUser({
          ...(response.data?.consents ? { consents: response.data.consents } : {}),
          hasRequiredInfo: {
            result: true,
            fields: { ...registration, first_name: body.first_name, surname: body.surname, phone: body.phone || registration?.phone }
          }
        }))
        dispatch(resetRegistration())
        replace('/login')
      } else {
        throw new Error('Wrong response')
      }
    } catch (error) {
      setStatus(STATUS.failed)
      showWarning(error)
    }
  }

  useEffect(() => {
    if (registration && typeof registration === 'object') {
      const savedFields = Object
        .entries(registration)
        .reduce((result, [key, value]) => {
          if (value) {
            const newKey = key === 'first_name'
              ? 'firstName'
              : key === 'surname'
                ? 'lastName'
                : key === 'email'
                  ? 'mail'
                  : key
            result = { ...result, [newKey]: value }
          }
          return result
        }, {})

      if (savedFields.phone) {
        Object.assign(savedFields, getPhoneParts(savedFields.phone, savedFields.prefix))
      }

      if (Object.keys(savedFields).length > 0) {
        dispatch(updateValues(savedFields))
      }
    }
  }, [dispatch, registration])

  return (
    <>
      <div className='registration'>
        {registration
          ? <div className='registration__title title'>
            <div>{t('userDetails')}</div>
            <div>{t('fillInMissingDetails')}</div>
          </div>
          : <div className='registration__title title group'>
            <div>{t('createYourAccount')}</div>
            {/* <div>{t('orGoTo')} <span
              className='--link'
              onClick={() => {
                if (goToLoginForm) goToLoginForm()
                else replace('/login')
              }}>
              {t('login')}
            </span>
            </div> */}
            {button}
          </div>}

        {popup.type && <>
          {popup.type === 'consent' ? <ConsentPreviewPopup
            type={popup.content}
            close={hidePopup}
          /> : popup.type === 'verification' ? <VerificationPopup
            loginUser={() => loginUser(popup.content)}
            close={hidePopup}
          /> : popup.type === 'warning' ? <WarningPopup
            mail={popup.content}
            goToLoginForm={goToLoginForm}
            close={hidePopup}
          /> : <InaccessiblePopup
            desc={popup.content}
            close={hidePopup}
          />}
        </>}

        <div className='registration__main main center'>
          {status === STATUS.pending && <Loading middleOfPage />}

          <Form
            warning={warning}
            setWarning={setWarning}
            block={status === STATUS.pending}
            showWarning={mail => showPopup(mail, 'warning')}
            showConsentPopup={goToLoginForm
              ? (type) => { showPopup(type, 'consent') }
              : undefined
            }
            submit={content => {
              if (registration) updateUserData(content)
              else submit(content)
            }} />
        </div>
      </div>

      {isDesktop && !isBasketEmpty && <div className='orderInfo__aside'>
        <SimplifiedSummary />
      </div>}
    </>
  )
}

export default Registration